export const subscriptions = [
    {
        id: 'facialRejuvenation',
        title: 'Омоложение лица',
        items: [
            {
                id: 1,
                title: 'R - SLEEK FACE (Курс 10)',
                duration: '6 ч 40 мин',
                services: 10,
                price: '35 000 ₽',
                saving: '12%',
                oldPrice: 40000,
                slug: 24426378,
            },
        ],
    },
    {
        id: 'bodyCorrection',
        title: 'Аппаратная коррекция',
        items: [
            {
                id: 1,
                title: 'R - Sleek 6 процедур',
                duration: '6 ч',
                services: 6,
                description: '60 мин, каждая процедура',
                price: '25 000 ₽',
                saving: '13%',
                oldPrice: 29000,
                slug: 24484059,
            },
            {
                id: 2,
                title: 'R - Sleek 6 процедур',
                duration: '4 ч 30 мин',
                services: 6,
                description: '45 мин, каждая процедура',
                price: '22 500 ₽',
                saving: '11%',
                oldPrice: 25500,
                slug: 24484149,
            },
        ],
    },
    {
        id: 'manualMassage',
        title: 'Ручной массаж',
        items: [
            {
                id: 1,
                title: 'Массаж спины 30 мин',
                duration: '5 ч',
                services: 10,
                description: '10 сеансов',
                price: '25 000 ₽',
                saving: '17%',
                oldPrice: 30500,
                slug: 24484509,
            },
            {
                id: 2,
                title: 'Массаж спины 30 мин',
                duration: '2 ч 30 мин',
                services: 5,
                description: '5 сеансов',
                price: '13 500 ₽',
                saving: '10%',
                oldPrice: 15000,
                slug: 24484536,
            },
            {
                id: 3,
                title: 'Классический массаж 55 мин',
                duration: '5 ч',
                services: 5,
                description: '5 сеансов',
                price: '21 000 ₽',
                saving: '7%',
                oldPrice: 23000,
                slug: 24484599,
            },
            {
                id: 4,
                title: 'Антицеллюлитный массаж 60 мин',
                duration: '5 ч',
                services: 5,
                description: '5 сеансов',
                price: '22 500 ₽',
                saving: '10%',
                oldPrice: 25000,
                slug: 24484665,
            },
            {
                id: 5,
                title: 'Relax 90 мин',
                duration: '7 ч 30 мин',
                services: 5,
                description: '5 сеансов',
                price: '32 500 ₽',
                oldPrice: 0,
                slug: 24484749,
            },
        ],
    },
]
